<template>
  <Row
    class="page3 financingInner"
    style="padding-left: 4vw; padding-right: 4vw"
  >
  <el-dialog title="修改选项" :visible.sync="dialogVisibleOption">
      <el-input v-model="newOptionValue" placeholder="请输入新选项值" />
      <span slot="footer" class="dialog-footer">
        <Button @click="dialogVisibleOption = false" style="padding:4px 15px;margin-right:15px;">取消</Button>
        <Button color="#bf9d63" type="primary" @click="modifyOption" style="padding:4px 15px;background-color: rgb(147, 127, 86);border-color:rgb(147, 127, 86);" v-if="newOptionValue">确认</Button>
      </span>
    </el-dialog>
    <div
    v-if="false"
      style="
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 88;
        left: 0;
        top: 2.5vw;
      "
    >
      <div class="changeWrap">
        <!-- <img :src="$images.change" alt="" /> -->
        <!-- <span>切换</span> -->
      </div>
      <div style="display: flex; align-items: center">
        <!-- <img
          @click="$router.back()"
          :src="$images.logo"
          style="width: 3vw; height: 3vw; cursor: pointer"
          alt=""
        /> -->
        <Select
          style="width: 100px; margin-left: 15px"
          placeholder="请选择年份"
          class="myselect"
          v-model="year"
        >
          <Option :value="item" v-for="item in arrYear" :key="item">{{
            item
          }}</Option>
        </Select>
        <Select
          style="width: 100px; margin-left: 15px"
          placeholder="请选择月份"
          class="myselect"
          v-model="month"
        >
          <Option :value="item" v-for="item in arrMonth" :key="item">{{
            item
          }}</Option>
        </Select>
        <Button
          @click="choseYearMonth()"
          type="warning"
          ghost
          style="
            cursor: pointer;
            margin-left: 15px;
            color: #bf9d63;
            border: solid 1px #bf9d63;
          "
          >完成</Button
        >
      </div>
    </div>
    <el-dialog
      class="platedialog"
      title="关联关系图谱"
      top="0"
      :visible.sync="dialogVisible"
      width="100%"
    >
      <div class="echartRelate" style="height: 100vh">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          id="svgId"
          height="1000"
          width="100%"
        ></svg>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <el-dialog
      class="platedialog full-screen-dialog"
      title="关联关系图谱"
      top="0"
      custom-class="full-screen-dialog"
      :visible.sync="dialogVisibleEcharts"
       width="100%"
      height="100%"
    >
    <div ref="chartContainer" id="chartContainer" style="width:100%;height:100%;background-color: #FFF;"></div>

      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <div class="part1" v-if="step == 'part1'">
      <div v-if="uploadType == '新增查询'">
      <div class="top">
        <div class="left">合同文本识别</div>
        <div class="right">
          <Button
            v-if="this.echarsData.isRel === true || this.echarsData.isRel === false"
            type="warning"
            style="border: 1px solid #4d4a48; background: #bf9d63"
            @click="stepDo('confirm')"
            >确认</Button
          >
          <!-- <Button
            type="warning"
            style="border: 1px solid #4d4a48; background: #bf9d63;margin-left:15px;"
            @click="stepDo('back')"
            >返回</Button> -->
        </div>
      </div>
      <div style="display: flex;justify-content: space-between">
      
      <div class="flow">
        <div class="yellowCorner">
          <div>
          <div class="flowLeft">
            <div class="dot"></div>
            <div class="word">上游</div>
          </div>
          <div class="flowCenter overHeight">
           
            <el-upload
              class="upload-demo"
              action=""
              :http-request="(e) => uploadFile(e, 'up')"
              :limit="1"
              name="cover"
              :multiple="false"
              :auto-upload="true"
              :show-file-list="false"
              :file-list="fileListUp"
            >
              <el-button  class="uploadButton" slot="trigger" type="primary"
                >{{JSON.stringify(uploadData.upData).length > 2?'重新':''}}上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
              <div class="el-upload__tip" style="padding-left:10px;">
              请上传.jpg.png.doc.docx.pdf格式的合同文件.
            </div>
            </el-upload>
          </div>
          <div class="flowLeft" style="margin-top:2vh;margin-bottom:2vh;" v-if="JSON.stringify(uploadData.upData).length > 2">
            <div class="dot"></div>
            <div class="word">合同内容审阅</div>
          </div>
          <div class="flowRight overHeight" v-if="JSON.stringify(uploadData.upData).length > 2">
            <div class="content2" style="width:100%;height:100%;display:flex;align-items:center">
              <div style="color:#bf9d63;text-decoration: underline;cursor: pointer;font-size:1.2vw;" @click="toDisfinancingtrade_new('up')">
               {{uploadData.upData.isSuspected?'疑似融资性贸易':'非融资性贸易'}}
                </div>
                <Button
                type="warning"
                style="padding:2px 5px;font-size:12px;border: 1px solid #4d4a48; background: #bf9d63;margin-left:15px;"
                @click="stepDo('updateUp')"
                >更新</Button>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="flow">
        <div class="yellowCorner">
          <div>
          <div class="flowLeft">
            <div class="dot"></div>
            <div class="word">下游</div>
          </div>
          <div class="flowCenter overHeight">
           
            <el-upload
              class="upload-demo"
              action=""
              :http-request="(e) => uploadFile(e, 'down')"
              :limit="1"
              name="cover"
              :multiple="false"
              :auto-upload="true"
              :show-file-list="false"
              :file-list="fileListDown"
            >
              <el-button  class="uploadButton" slot="trigger" type="primary"
                >{{JSON.stringify(uploadData.downData).length > 2 ? '重新':''}}上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
              <div class="el-upload__tip" style="padding-left:10px;">
              请上传.jpg.png.doc.docx.pdf格式的合同文件.
            </div>
            </el-upload>
          </div>
          <div class="flowLeft" style="margin-top:2vh;margin-bottom:2vh;" v-if="JSON.stringify(uploadData.downData).length > 2">
            <div class="dot"></div>
            <div class="word">合同内容审阅</div>
          </div>
          <div class="flowRight overHeight" v-if="JSON.stringify(uploadData.downData).length > 2">
            <div class="content2" style="width:100%;height:100%;display:flex;align-items: center;">
              <div style="color:#bf9d63;text-decoration: underline;cursor: pointer;font-size:1.2vw;" @click="toDisfinancingtrade_new('down')">
               {{uploadData.downData.isSuspected?'疑似融资性贸易':'非融资性贸易'}}
                </div>
                <Button
                type="warning"
                style="padding:2px 5px;font-size:12px;border: 1px solid #4d4a48; background: #bf9d63;margin-left:15px;"
                @click="stepDo('updateDown')"
                >更新</Button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="flow" style="width: 100%;margin-top: 2vh;" v-if="JSON.stringify(uploadData.upData).length > 2 && JSON.stringify(uploadData.downData).length > 2">
    <div class="yellowCorner">
          <div class="flowLeft">
            <div class="dot"></div>
            <div class="word">关联关系查询</div>
          </div>
          <div class="flowRight" style="margin-top:1vh;">
              <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;padding:2vh;">
                <div>
                  <el-select v-model="relCompany1" placeholder="请选择" class="relationSelect">
                    <el-option
                      v-for="item in uploadData.upData.relList"
                      :key="item"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                  <el-button
                  v-if="relCompany1"
                  @click="openDialog('up')" type="primary" style="
                  margin-left:10px;
                  display: inline-block;
                  line-height: 1;
                  white-space: nowrap;
                  cursor: pointer;
                  background: #fff;
                  border: 1px solid #dcdfe6;
                  color: #606266;
                  -webkit-appearance: none;
                  text-align: center;
                  box-sizing: border-box;
                  outline: none;
                  transition: .1s;
                  font-weight: 500;
                  -moz-user-select: none;
                  -webkit-user-select: none;
                  -ms-user-select: none;
                  padding: 12px 20px;
                  font-size: 14px;
                  border-radius: 4px;
                  border-color:#bf9d63;background-color: #bf9d63;color:#FFF;">修改选项值</el-button>

                  </div>


                  <div>
                  <el-select v-model="relCompany2" placeholder="请选择" class="relationSelect">
                    <el-option
                      v-for="item in uploadData.downData.relList"
                      :key="item"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                  <el-button
                  v-if="relCompany2"
                  @click="openDialog('down')" type="primary" style="
                  margin-left:10px;
                  display: inline-block;
                  line-height: 1;
                  white-space: nowrap;
                  cursor: pointer;
                  background: #fff;
                  border: 1px solid #dcdfe6;
                  color: #606266;
                  -webkit-appearance: none;
                  text-align: center;
                  box-sizing: border-box;
                  outline: none;
                  transition: .1s;
                  font-weight: 500;
                  -moz-user-select: none;
                  -webkit-user-select: none;
                  -ms-user-select: none;
                  padding: 12px 20px;
                  font-size: 14px;
                  border-radius: 4px;
                  border-color:#bf9d63;background-color: #bf9d63;color:#FFF;">修改选项值</el-button>

                  </div>


              </div>
            </div>
            <div v-if="relCompany1 && relCompany2" style="display: flex;align-items: center;margin-top:2vh;">
            <el-button @click="getRelApi" style="position: static;transform: none;margin-right: 15px;" class="uploadButton" type="primary"
                >查询</el-button>
              <div style="color:#bf9d63;text-decoration: underline;cursor: pointer;font-size:1.2vw;" @click="showEcharts()">
                {{ this.echarsData.isRel === true?'存在关联关系': this.echarsData.isRel === false?'不存在关联关系':''}}
              </div>
            </div>
              </div>
            </div>
  </div>
  <div v-if="uploadType == '批量查询'">
    <div class="right" style="text-align: right;padding-bottom: 15px;">
          <Button
            type="warning"
            style="border: 1px solid #4d4a48; background: #bf9d63;margin-left:15px;"
            @click="stepDo('back')"
            >返回</Button>
        </div>
    <div style="display: flex;justify-content: center;">
      
      <div class="flow">
        <div class="yellowCorner">
          <div>
          <div class="flowLeft">
            <div class="dot"></div>
            <div class="word">批量上传</div>
          </div>
          <div class="flowCenter overHeight">
            <el-upload
              class="upload-demo"
              action="#"
              ref="upload"
              :http-request="(e) => uploadFile(e, 'batch')"
              :limit="1"
              name="cover"
              :multiple="false"
              :auto-upload="true"
              :show-file-list="false"
              :file-list="fileListBatch"
            >
              <el-button class="uploadButton" slot="trigger" type="primary"
                >上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
              <div class="el-upload__tip" style="padding-left:10px;">
        请上传.zip格式的合同文件压缩包，压缩包中仅包括需要处理的合同文件.
      </div>
              <template #tip>
      
    </template>
            </el-upload>
          </div>
       
        </div>
      </div>
      </div>
    </div>
</div>
    </div>
    <div class="part2" v-if="step == 'part2'">
      <div class="topList" style="justify-content: space-between;">
        <div>
        <div class="item" v-for="item in contractTopList">
          <div class="yellowCorner">
            <div class="itemTitle" style="font-size: 0.9vw">
              {{ item.name }}
            </div>
            <div class="content">
              <span class="num" style="font-size: 1.5vw">{{ item.num }}</span>
              <span class="unit">{{ item.unit }}</span>
            </div>
          </div>
        </div>
        </div>
        <div style="display:flex;align-items: center;">
          <el-button style="margin-right:1vw;" class="custom-button" size="large" @click="newQuwery('新增查询')">
          新增查询
          </el-button><el-button class="custom-button" size="large" @click="newQuwery('批量查询')" v-if="!folderName && batchFlag">
          批量查询
          </el-button>
          <el-popover
          v-if="folderName && batchFlag"
          trigger="hover"
          placement="bottom"
          width="160"
          >
          <div>批量审阅进行中</div>
           <el-progress :percentage="progress || 0" color="#bf9d63"></el-progress>
            <i slot="reference" style="cursor: pointer;margin-left:1vw;font-size:2.5vw;color:rgb(191, 157, 99);" class="el-icon-time"></i>
          </el-popover>


</div>
      </div>
      <div class="tableWrap">
        <div class="yellowCorner overHeight">
          <div class="tableList overHeight">
            <div class="titleWrap borderRight">
              
              <div
                class="padding1 borderTop borderRight borderLeft borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 8vw;
                  height: 4vw;
                "
              >
                日期
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 6vw;
                  height: 4vw;
                "
              >
                是否成对
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 10vw;
                  height: 4vw;
                "
              >
                上游合同
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 6vw;
                  height: 4vw;
                "
              >
                审阅结果
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 10vw;
                  height: 4vw;
                "
              >
                下游合同
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 6vw;
                  height: 4vw;
                "
              >
                审阅结果
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 17.9vw;
                  height: 4vw;
                "
              >
                关联关系上游
              </div>
              <div
                class="padding1 borderTop borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 17.9vw;
                  height: 4vw;
                "
              >
                关联关系下游
              </div>
              <div
                class="padding1 borderTop borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 8.05vw;
                  height: 4vw;
                "
              >
                关联关系预警
              </div>
            </div>
            <div
              v-for="item in paginatedData"
              class="titleWrap borderRight"
              style="background: none; color: #fff"
            >
              <div>
                <div style="display: flex; align-items: center">
                  <div
                    class="padding1 borderLeft borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                  {{ item["date"] }}
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 6vw; text-align: center"
                  >
                  {{ item.type }}
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 10vw; text-align: center"
                  >
                  <el-link
                      target="_blank"
                      :href="'/brightfood_platform_pc/#/disfinancingtradeNew?filename='+item['upfileName']"
                      type="warning"
                      style="color: #bf9d63"
                      > {{ item["upfileName"] }}</el-link
                    >
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 6vw; text-align: center"
                  >
                  {{ item["upfileName"]?(item.upReport?1:0):'' }}
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 10vw; text-align: center"
                  >
                  <el-link
                      target="_blank"
                      :href="'/brightfood_platform_pc/#/disfinancingtradeNew?filename='+item['downfileName']"
                      type="warning"
                      style="color: #bf9d63"
                      > {{ item["downfileName"] }}</el-link
                    >
                   
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 6vw; text-align: center"
                  >
                  {{ item["downfileName"]?(item.downReport?1:0):'' }}

                  </div>
                 
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 17.9vw; text-align: center"
                  >
                  {{ item.relcompany1 }}
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 17.9vw; text-align: center"
                  >
                  {{item.relcompany2}}
                  </div>
                  <div
                    class="padding1 borderBottom"
                    style="width: 8.05vw; text-align: center"
                  >
                    <span
                     v-if="item.relcheck || item.relcheck === false "
                      @click="showEchartsInList(item['reljson'])"
                      style="cursor: pointer;color:rgb(191, 157, 99);"
                      >{{ item.relcheck?'有关联':'无关联' }}</span
                    >
                    <span
                    v-else 
                      style="color:rgb(191, 157, 99);"
                      ></span
                    >
                  </div>
            
                </div>
              </div>
            </div>
            <el-pagination
              style="text-align: right; margin-top: 1vw"
              background
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </Row>
</template>

<script>
import { useDataStore } from "@/store";
import { mapActions } from "pinia";
import { Loading } from "element-ui";
import relationJson from "./relation.json";
import * as d3 from "d3";
import { getAllContractDetailsOrdered,contractUpload,getRel,contractUploadMultipe,addContractDetail,contractPdfurlAndSuspected,getTaskProgress } from "../api";

// ===== 绘图 =====
function drawMarker() {
  d3.select("svg")
    .append("svg:defs")
    .append("svg:marker")
    .attr("id", "blueMarker")
    .attr("viewBox", "0 -5 10 10")
    .attr("refX", 70)
    .attr("refY", 0)
    .attr("markerUnits", "userSpaceOnUse")
    .attr("markerWidth", 6)
    .attr("markerHeight", 6)
    .attr("orient", "auto")
    .append("svg:path")
    .attr("d", "M0,-5L10,0L0,5")
    .attr("fill", (d) => {
      return "#000000";
    });
  d3.select("svg")
    .select("defs")
    .append("svg:marker")
    .attr("id", "redMarker")
    .attr("viewBox", "0 -5 10 10")
    .attr("refX", 70)
    .attr("refY", 0)
    .attr("markerUnits", "userSpaceOnUse")
    .attr("markerWidth", 6)
    .attr("markerHeight", 6)
    .attr("orient", "auto")
    .append("svg:path")
    .attr("d", "M0,-5L10,0L0,5")
    .attr("fill", "#fd6568");
}

function drawCircle(id) {
  let circleG = d3.select(`#${id}`).attr("class", "circle-g");
  circleG
    .append("circle")
    .attr("class", "real-circle")
    .attr("fill", (d) => {
      // 某个企业详情页点击进来的，给个这个企业特殊样式
      if (d.isSelf) {
        return "#fe9d3b";
      }
      if (String(d.type).indexOf("important") > -1) {
        return "#fe5557";
      }
      if (String(d.type).indexOf("person") > -1) {
        return "#4d2fe1";
      }
      return "#52a3eb";
    })
    .attr("stroke", function (d) {
      if (d.isSelf) {
        return "#ec8a2f";
      } else if (String(d.type).indexOf("person") > -1) {
        return "#0082e5";
      }
      return "none";
    })
    .attr("x", (d) => {
      return d.x})
      .attr("y", (d) => {
      return d.y})
    // 设置圆圈半径
    .attr("r", (d) => {
      return d.r
      if (String(d.type).indexOf("person") > -1) {
        return 23;
      }
      if (String(d.type).indexOf("important") > -1) {
        return 48;
      }
      return 35;
    });
}

function drawText(id) {
  d3.select(`#${id}`)
    .insert("text")
    .attr("class", "circle-text")
    .attr("dy", ".35em")
    .attr("text-anchor", "middle")
    .attr("font-size", 12)
    .style("fill", function (node) {
      return "#fff";
    })
    .attr("y", (d) => {
      return d.x;
    })
    .attr("x", function (d) {
      let re_en = /[a-zA-Z]+/g;
      //如果是全英文，不换行
      if (d.name.match(re_en)) {
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 2)
          .text(function () {
            return d.name;
          });
      }
      //如果小于四个字符，不换行
      else if (d.name.length <= 4) {
        d3.select(this)
          .append("tspan")
          .attr("x", -2)
          .attr("y", 2)
          .text(function () {
            return d.name;
          });
      } else if (d.name.length > 4 && d.name.length <= 8) {
        //大于4  这两行
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -7)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot;
          });
      }
      // 文字长度大于8 折三行
      else if (d.name.length > 8 && d.name.length <= 12) {
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -15)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 2)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 16)
          .text(function () {
            return bot1;
          });
      }
      //文字长度大于12 折四行
      else if (d.name.length > 12 && d.name.length <= 16) {
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, 12);
        let bot2 = d.name.substring(12, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -20)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -3)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot1;
          });
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 23)
          .text(function () {
            return bot2;
          });
      } else if (d.name.length > 16) {
        //文字长度大于16  方案
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, 12);
        let bot2 = d.name.substring(12, 14);

        bot2 += "...";
        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -22)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -7)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot1;
          });
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 25)
          .text(function () {
            return bot2;
          });
      }
    });
}

function drawLinkPath(container, links) {
  // 添加连接路径path
  container
    .append("g")
    .attr("class", "line-path")
    .selectAll(".path")
    .data(links)
    .enter()
    .append("path")
    .attr("class", "path")
    .attr("fill", "none")
    .attr("stroke-dasharray", function (d) {
      if (String(d.type).indexOf("dash") > -1) {
        return 5.5;
      }
      return "none";
    })
    .attr("stroke-width", 1)
    .attr("stroke", function (d) {
      if (d.color) {
        return d.color;
      }
      return "#000000";
    })
    .attr("marker-end", function (d) {
      let id = "blueMarker";
      if (d.type === "投资") {
        id = "redMarker";
      }
      return `url(#${id})`;
    })
    .attr("cursor", "pointer");
}

function drawRelationText(container, links,linkGroup) {
  for(let i in linkGroup){
    let edges_text = container
    .append("g")
    .attr("class", "relation-text")
    .selectAll(".linetext")
    .data(linkGroup[i])
    .enter()
    .append("svg:g")
    .attr("class", "linetext")
    .attr("fill-opacity", 1);

    edges_text
    .append("svg:text")
    .attr("font-size", 10)
    .attr("fill", "#8e8e8e")
    .attr("y", ".31em")
    .attr("dy", function(d,i){
      return (i+1.5)+'em'
    })
    .attr("text-anchor", "middle")
    .text(function (d) {
      return d.value;
    });
  }
}

function formatNode(nodes) {
  let name = "";
  nodes.forEach((node) => {
    if (name === node.name) {
      node.isSelf = true;
    }
    node.idx = "zf" + uuid();
  });
}
// 格式化连接关系数据
function formatLink(links, nodes) {
  links.forEach((link, i) => {
    link.index = i;
    let src = nodes.find((node) => node.name == link.source);
    let dst = nodes.find((node) => node.name == link.target);
    link["source"] = src;
    link["target"] = dst;
  });
}
function uuid() {
  return Math.random().toString(34).replaceAll(/\,|\./g, "");
}

// ===== 更新 =====
function tick() {
  try {
    updateLinkLine();
    updateCircleAndText();
    updateLinkRelationText();
  } catch (error) {
    console.error("Error in tick:", error);
  }
}
function updateCircleAndText() {
  d3.selectAll("circle")
    .attr("cx", (d) => {
      return d.x;
    })
    .attr("cy", (d) => d.y);
  d3.selectAll(".circle-text").attr("transform", (d) => {
    return `translate(${d.x},${d.y})`;
  });
}
function updateLinkLine() {
  let edges_line = d3.selectAll(".path");
  edges_line.attr("d", function (d) {
    return (
      "M" +
      d.source.x +
      " " +
      d.source.y +
      " L " +
      d.target.x +
      " " +
      d.target.y
    );
  });
}
function updateLinkRelationText() {
  let svg = d3.select("svg");
  let edges_text = svg.selectAll(".linetext");

  //更新连接线上文字的位置
  edges_text.attr("transform", function (d) {
    let translateX = (d.source.x + d.target.x) / 2;
    let translateY = (d.source.y + d.target.y) / 2;
    return `translate(${translateX},${translateY}) rotate(0)`;
  });
}
export default {
  name: "page3",
  components: {},
  computed: {
    total() {
      return this.listAnswer.length;
    },
    paginatedData() {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      return this.listAnswer.slice(start, end);
    },
  },
  created() {
    let userInfo = localStorage.getItem("bbsUserInfo");
    let userInfoJson = JSON.parse(userInfo);
    if (userInfoJson.roleName != "融资性贸易权限") {
      Message.error("当前用户无权限，即将跳转 请稍候...");
      setTimeout(() => {
        window.location.href = "https://community.gmfintl.com/app/saml2/login";
      }, 1500);
      return
    }
    // if(localStorage.getItem('folderName')){
    //   this.folderName = localStorage.getItem('folderName')
    //   this.getTaskProgressApi()
    // }
    this.getTaskProgressApi()
    this.getList()
    // this.listAnswer = relationJson;
    this.content1new = this.content1;
    this.content2new = this.content2;
    this.content3new = this.content3;
    this.content4new = this.content4;
    this.content1 = "";
    this.content2 = "";
    this.content3 = "";
    this.content4 = "";
    // sysLogin()
    this.setTitle("融资性贸易AI识别工具");
    this.setLeftTop(false);
    this.setRightTop(false);

    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    if (day <= 15) {
      if (month == 1) {
        month = 11;
        year--;
      } else if (month == 2) {
        month = 12;
        year--;
      } else {
        month = month - 2;
      }
    } else {
      if (month == 1) {
        month = 12;
        year--;
      } else {
        month--;
      }
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.year = year;
    this.month = month;
    let beforeYear = year - 50;
    let arrYear = [];
    while (beforeYear < year) {
      arrYear.push(year--);
    }
    arrYear = arrYear.filter((item) => item > 2020);
    this.arrYear = arrYear;
    let arrMonth = [];
    for (let i = 1; i <= 12; i++) {
      let month2 = i < 10 ? "0" + i : "" + i;
      arrMonth.push(month2);
    }
    this.arrMonth = arrMonth;
  },
  data() {
    
    return {
      batchFlag:false,
      folderName:undefined,
      progress: 0, // 进度条的初始百分比
      echarsData:{},
      relCompany1:'',
      relCompany2:'',
      uploadData:{
        upData:{}, 
        downData:{},
        batchData:{}
      },
      fileListUp:[],
      fileListDown:[],
      fileListBatch:[],
      uploadType:'新增查询',//新增类型
      dialogVisibleEcharts:false,//echarts关系图
      selectedOption: '',  // 当前选择的值
      options: [           // 下拉选项
        { value: 'A' },
        { value: 'B' },
      ],
      dialogVisibleOption: false, // 控制弹框显示隐藏
      newOptionValue: '',   // 存储新输入的选项值
      simulation: null,
      currentPage: 1, // 当前页码
      pageSize: 4, // 每页显示条数
      listAnswer: [],
      contractTopList: [
        {
          name: "总查询记录数",
          num: "",
          unit: "条",
        },
        {
          name: "合同审阅预警",
          num: "",
          unit: "条",
        },
        {
          name: "关联关系预警",
          num: "",
          unit: "条",
        }
      ],
      dialogVisible: false,
      fileList: [],
      step: "part1",
      content1: ``,
      content2: ``,
      content3: ``,
      content4: ``,
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setRightTop"]),
    reset(){
      this.echarsData = {}
      this.relCompany1 = ''
      this.relCompany2 = '',
      this.uploadData ={
        upData:{}, 
        downData:{},
        batchData:{}
      }
      this.fileListUp = []
      this.fileListDown = []
      this.fileListBatch = []
      // this.uploadType =''//新增类型
      this.dialogVisibleEcharts = false//echarts关系图
      this.selectedOption = ''  // 当前选择的值
    },
    stepDo(type){
      if(type == 'back'){
        this.reset()
        this.step = 'part2'
      }
      if(type == 'updateUp'){
        this.contractPdfurlAndSuspectedApi('up')
      }
      if(type == 'updateDown'){
        this.contractPdfurlAndSuspectedApi('down')
      }
      if(type == 'confirm'){
        addContractDetail({
          "downReport": this.uploadData.downData.isSuspected,
          "downfileName": this.uploadData.downData.filename,
          "downpdfUrl": this.uploadData.downData.downPdfUrl,
          "processedjson": this.echarsData.originalJson,
          "relcheck": this.echarsData.isRel,
          "relcompany1": this.relCompany1,
          "relcompany2": this.relCompany2,
          "reljson": this.echarsData.echartData,
          "type": "成对",
          "upReport": this.uploadData.upData.isSuspected,
          "upfileName": this.uploadData.upData.filename,
          "uppdfUrl": this.uploadData.upData.upPdfUrl
        }).then(res=>{
          if(res.code == 200){
            this.$message.success('添加成功')
            this.step = 'part1'
            this.reset()
            // this.getList()
          }
        })
      }
    },
    toDisfinancingtrade_new(type){
      if(type == 'up'){
        window.open('/brightfood_platform_pc/#/disfinancingtradeNew?filename='+this.uploadData.upData.filename, '_blank');
       
      }else if(type == 'down'){
        window.open('/brightfood_platform_pc/#/disfinancingtradeNew?filename='+this.uploadData.downData.filename, '_blank');
      }
    },
    getList(){
      getAllContractDetailsOrdered().then(res=>{
        if(res.code == 200){
          this.listAnswer = res.data.list
          this.contractTopList = [].concat([
        {
          name: "总查询记录数",
          num: res.data['总查询记录数'],
          unit: "条",
        },
        {
          name: "合同审阅预警",
          num: res.data['合同审阅预警'],
          unit: "条",
        },
        {
          name: '关联关系预警',
          num: res.data['关联关系预警'],
          unit: "条",
        }
      ])
        }
      })
//       this.uploadData.upData = {
//         filename:'DNCG20230434-脂肪粉-双章',
//         isSuspected:false,
//         relList:["内蒙古聚牧城科技有限责任公司"
// ,"上海鼎牛饲料有限公司"]
//       }
//       this.uploadData.downData = {
//         filename:"DNCG20240909_8.2浙江一景乳业300吨玉米合同(1)",
//         isSuspected:false,
//         relList:["上海鼎牛饲料有限公司"
// ,"浙江一景生态牧业有限公司"]
//       }
    },
    openDialog(type) {
      this.currentRelType = type
      if(type == 'up'){
        this.newOptionValue = this.relCompany1
      }
      if(type == 'down'){
        this.newOptionValue = this.relCompany2
      }
      this.dialogVisibleOption = true;  // 打开弹框
    },
    modifyOption() {
      if(this.currentRelType == 'up'){
        const index = this.uploadData.upData.relList.findIndex(option => option === this.relCompany1);
        if (index !== -1) {
          this.uploadData.upData.relList[index] = this.newOptionValue;
          this.relCompany1 = this.newOptionValue; // 同步更新选择的值
        }
      this.dialogVisibleOption = false; // 关闭弹框
      }
      if(this.currentRelType == 'down'){
        const index = this.uploadData.downData.relList.findIndex(option => option === this.relCompany2);
        if (index !== -1) {
          this.uploadData.downData.relList[index] = this.newOptionValue;
          this.relCompany2 = this.newOptionValue; // 同步更新选择的值
        }
      this.dialogVisibleOption = false; // 关闭弹框
      }
      
    },
    newQuwery(type){
      this.uploadType = type
      if(type == '新增查询'){
        this.step = 'part1'
      }else if(type == '批量查询'){
        this.step = 'part1'
      }
    },
    showSvg(relation) {
      if (relation) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getSvgDetail(relation);
        });
      } else {
        this.$message.info("未发现10层内关联关系");
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handlePageChange(val) {
      this.currentPage = val;
    },
    handelChange(file, fileList) {
      this.fileList = fileList;
      console.log("文件修改执行的函数", file, fileList);
    },
    handleRemove(file, fileList) {
      console.log("移除文件执行的函数", file, fileList);
      this.filesList = fileList;
    },
    handlePreview(file) {
      console.log("点击已经上传的文件", file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 上传成功后的回调
    handleSuccess(response, file, fileList) {
      this.fileList = [];  // 清空文件列表
    },
    beforeRemove(file, fileList) {
      console.log("移除之前执行的函数", fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    showEchartsInList(data){
      this.dialogVisibleEcharts = true
      this.$nextTick(()=>{
        let myChart = this.$echarts(this.$refs.chartContainer);
      myChart.clear();
      myChart.resize();
      // 定义数据对象
let option = {
  tooltip: {
    formatter: function (params) {
      if (params.dataType === 'node') {
        return params.data.name;
      } else {
        return params.data.value;
      }
    }
  },
  legend: [
    {
      data: ['公司', '个人', '源公司/目标公司'],
      left: 'left',
      orient: 'vertical',
      top: 'top'
    },
    {
    data: [
      {
        name: '强关联关系',
        itemStyle: { color: '#ff0000' }
      },
      {
        name: '弱关联关系',
        itemStyle: { color: '#ffa500' }
      },
      {
        name: '一般关联关系',
        itemStyle: { color: '#000000' }
      }
    ],
      left: 'right',
      orient: 'vertical',
      top: 'top',
      itemWidth: 30,
      itemHeight: 2,
      textStyle: {
        fontSize: 12
      }
    }
  ],
  series: [{
    type: 'graph',
    layout: 'force',
    symbolSize: 40,
    roam: true,
    draggable: true,
    label: {
      show: true,
      fontSize: 12
    },
    edgeSymbol: ['circle', 'arrow'],
    edgeSymbolSize: [4, 10],
    edgeLabel: {
      show: true,
      formatter: function (params) {
        return params.data.value;
      },
      fontSize: 12,
      padding: [4, 8],
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      borderRadius: 4,
      lineHeight: 20,
      color: '#333'
    },
    data: data.nodes.map(node => ({
      name: node.name,
      symbolSize: node.symbolSize,
      category: node.type === 'company' ? 0 : (node.type === 'person' ? 1 : (node.type === 'research' ? 2 : 0))
    })),
    links: data.links.map(link => ({
      source: link.source,
      target: link.target,
      value: link.value,
      lineStyle: { 
        color: link.color,
        width: 2
      },
      category: link.color === '#ff0000' ? '强关联关系' :
                (link.color === '#ffa500' ? '弱关联关系' : '一般关联关系')
    })),
    categories: [
      { name: '公司' },
      { name: '个人' },
      { name: '源公司/目标公司' },
      { name: '强关联关系' },
      { name: '弱关联关系' },
      { name: '一般关联关系' }
    ],
    force: {
      repulsion: 1000,
      edgeLength: [50, 350]
    },
    lineStyle: {
      opacity: 0.9,
      width: 2,
      curveness: 0
    }
  }]
};
      // 配置图表数据
      myChart.setOption(option);
      })
    },
    showEcharts(){
      this.dialogVisibleEcharts = true
      this.$nextTick(()=>{
        let myChart = this.$echarts(this.$refs.chartContainer);
      myChart.clear();
      myChart.resize();
      // 定义数据对象
const data = this.echarsData.echartData
let option = {
  tooltip: {
    formatter: function (params) {
      if (params.dataType === 'node') {
        return params.data.name;
      } else {
        return params.data.value;
      }
    }
  },
  legend: [
    {
      data: ['公司', '个人', '源公司/目标公司'],
      left: 'left',
      orient: 'vertical',
      top: 'top'
    },
    {
    data: [
      {
        name: '强关联关系',
        itemStyle: { color: '#ff0000' }
      },
      {
        name: '弱关联关系',
        itemStyle: { color: '#ffa500' }
      },
      {
        name: '一般关联关系',
        itemStyle: { color: '#000000' }
      }
    ],
      left: 'right',
      orient: 'vertical',
      top: 'top',
      itemWidth: 30,
      itemHeight: 2,
      textStyle: {
        fontSize: 12
      }
    }
  ],
  series: [{
    type: 'graph',
    layout: 'force',
    symbolSize: 40,
    roam: true,
    draggable: true,
    label: {
      show: true,
      fontSize: 12
    },
    edgeSymbol: ['circle', 'arrow'],
    edgeSymbolSize: [4, 10],
    edgeLabel: {
      show: true,
      formatter: function (params) {
        return params.data.value;
      },
      fontSize: 12,
      padding: [4, 8],
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      borderRadius: 4,
      lineHeight: 20,
      color: '#333'
    },
    data: data.nodes.map(node => ({
      name: node.name,
      symbolSize: node.symbolSize,
      category: node.type === 'company' ? 0 : (node.type === 'person' ? 1 : (node.type === 'research' ? 2 : 0))
    })),
    links: data.links.map(link => ({
      source: link.source,
      target: link.target,
      value: link.value,
      lineStyle: { 
        color: link.color,
        width: 2
      },
      category: link.color === '#ff0000' ? '强关联关系' :
                (link.color === '#ffa500' ? '弱关联关系' : '一般关联关系')
    })),
    categories: [
      { name: '公司' },
      { name: '个人' },
      { name: '源公司/目标公司' },
      { name: '强关联关系' },
      { name: '弱关联关系' },
      { name: '一般关联关系' }
    ],
    force: {
      repulsion: 1000,
      edgeLength: [50, 350]
    },
    lineStyle: {
      opacity: 0.9,
      width: 2,
      curveness: 0
    }
  }]
};
      // 配置图表数据
      myChart.setOption(option);
      })
      
    },
    // 方法二
    handelSend() {
      let formdata = new FormData();
      //   定义一个fromdata对象用于
      this.formdata = formdata;
      //   触发提交文件(执行submit()这个函数会根据有多少个文件就执行多少次http-requests所绑定的函数)
      this.$refs.upload.submit();
      this.formdata.append("something", "something");
      //   发送请求,这里上传的的是this.fromdata而不是this.fileList
    },
    //获取上下游公司之间的关系
    getRelApi(){
      getRel({
        relCompany1:this.relCompany1,
        relCompany2:this.relCompany2
      }).then(res=>{
        if(res.code == 200){
          this.echarsData = res.data
        }
      })
    },
    contractPdfurlAndSuspectedApi(type){
      if(type == 'up'){
        contractPdfurlAndSuspected({fileName:this.uploadData.upData.filename}).then(res=>{
          if(res.code == 200){
            this.uploadData.upData.upPdfUrl = res.data.pdfUrl
            this.uploadData.upData.isSuspected = res.data.isSuspected
          }
        })
      }
      if(type == 'down'){
        contractPdfurlAndSuspected({fileName:this.uploadData.downData.filename}).then(res=>{
          if(res.code == 200){
            this.uploadData.downData.downPdfUrl = res.data.pdfUrl
            this.uploadData.downData.isSuspected = res.data.isSuspected
          }
        })
      }
    },
    getTaskProgressApi(){
      getTaskProgress({
        // folderName:this.folderName,
        noLoading:true
      }).then(res=>{
        this.batchFlag = true
        if(res.code == 200){
          this.progress = res.data?Number(res.data):0
          if(String(res.data).indexOf('100') > -1){
            this.folderName = false
            // localStorage.removeItem('folderName')
            this.getList()
          }else{
            if(res.msg == '无任务进行'){
              this.getList()
            }else{
              this.folderName = true
              this.getTaskProgressApi()
            }
          }
        }
      })
    },
    uploadFile(params, type) {
      let loading;
      loading = Loading.service({
        lock: true,
        text: "",
        background: "rgba(0, 0, 0, 0.01)",
        customClass:"yellowLoading"
      });
        if (type == "up") {
          contractUpload(params.file).then(res=>{
            if(res.code == 200){
              this.uploadData.upData = res.data
              if(res.data['relList'] && res.data['relList'].length > 0){
                this.relCompany1 = res.data['relList'][0]
              }else{
                this.relCompany1 = undefined
              }
              this.fileListUp = []
              this.contractPdfurlAndSuspectedApi('up')
            }
            loading.close();

          })
        }
        if (type == "down") {
          contractUpload(params.file).then(res=>{
            if(res.code == 200){
              this.uploadData.downData = res.data
              if(res.data['relList'] && res.data['relList'].length > 0){
                this.relCompany2 = res.data['relList'][0]
              }else{
                this.relCompany2 = undefined
              }
              this.fileListDown = []
              this.contractPdfurlAndSuspectedApi('down')
            }
            loading.close();
          })
        }
        if(type == 'batch'){
          contractUploadMultipe(params.file).then(res=>{
            this.fileListBatch = []
            if(res.code == 200){
              this.folderName = res.data.folderName
              // localStorage.setItem('folderName',this.folderName)
              this.$confirm('上传完成，点击确定回到明细页', '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              confirmButtonClass:"yellowButton",
              showClose:false,
              type: 'warning'
            }).then(() => {
            this.step = 'part2'
            this.getTaskProgressApi()
            loading.close();
            })
            }
          })
         
        }

      // 判断文件
      let formdata = new FormData();
      formdata.append("filename", params.file);
    },
    getSvgDetail(data) {
      d3.select("#svgId").selectAll("*").remove();
      let { nodes, links } = JSON.parse(JSON.stringify(data));
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      formatLink(links, nodes);
      formatNode(nodes);
      console.log(links,'分组前的links')
      let linkGroup = {}
      links.forEach(item=>{
        let key = item.source.name+":"+item.target.name
        if(linkGroup[key]){
          linkGroup[key].push(item)
        }else{
          linkGroup[key] = [item]
        }
      })
      console.log(linkGroup,22)
      let linkGroup2 = {
      }
      for(let i in linkGroup){
        let linkGroup2List =  Object.keys(linkGroup2)
        let res = linkGroup2List.findIndex(item=>{
          let first1 = item.split(':')[0]
          let second1 = item.split(':')[1]
          let first2 = i.split(':')[0]
          let second2 = i.split(':')[1]
          return ((first1 == first2) && (second1 == second2)) || ((first1 == second2) && (first2 == second1))
        })
        if(res > -1){
          linkGroup2[linkGroup2List[res]] = linkGroup2[linkGroup2List[res]].concat(linkGroup[i])
        }else{
          linkGroup2[i] = linkGroup[i]
        }
      }
      const simulation = d3
        .forceSimulation(nodes)
        .force("link", d3.forceLink(links).distance(380))
        .force("charge", d3.forceManyBody().strength(-300).distanceMax(380))
        .force("center", d3.forceCenter(width / 2, height / 2))
        .on("tick", tick);

      // 创建一个根容器，用于存放要画的图形
      let container = d3
        .select("#svgId")
        .append("g")
        .attr("class", "container")
        ;

      // 绘制连接线
      drawLinkPath(container, links);
      // 绘制关系文本
      drawRelationText(container, links,linkGroup2);
      // 绘制箭头
      drawMarker();
      // 圆圈和文字的外层g，可以在这个上面添加点击、hover事件
      let nodeSelection = container
        .append("g")
        .attr("class", "nodegroup")
        .selectAll(".node")
        .data(nodes)
        .enter()
        .append("g")
        .attr("id", (d) => {
          return d.idx;
        });

      // 遍历绘制圆圈和圆圈上的文本
      nodeSelection.each((d) => {
        drawCircle(d.idx);
        drawText(d.idx);
      });

      // ===== 拖拽 =====
      let dragFunc = d3
        .drag()
        .on("start", dragStarted)
        .on("drag", dragged)
        .on("end", dragend);

      dragFunc(nodeSelection);
      function dragStarted(d) {
        if (!d3.event.active) simulation.alphaTarget(0.01).restart();
        d.fx = d.x;
        d.fy = d.y;
      }
      function dragged(d) {
        d.fx = d3.event.x;
        d.fy = d3.event.y;
      }
      function dragend(d) {
        if (!d3.event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      }

      // ===== 缩放 =====
      initZoom();
      function initZoom() {
        let zoom = d3
          .zoom()
          .scaleExtent([0.6, 5])
          .on("zoom", () => {
            let transform = d3.event.transform;
            return container.attr(
              "transform",
              `translate(${transform.x},${transform.y})scale(${transform.k})`
            );
          });

        //动画持续时间
        container
          .transition()
          .duration(10)
          .call(zoom.transform, d3.zoomIdentity);
        d3.select("svg")
          .call(zoom)
          // 取消默认的双击放大事件
          .on("dblclick.zoom", null);
      }
    },
  },
  mounted() {
    if(this.$route.query.step){
      this.step = this.$route.query.step
    }
  },
  beforeDestroy() {
    this.setLeftTop(true);
    this.setRightTop(true);
  },
};
</script>
<style lang="less">
.full-screen-dialog{
  .el-dialog__wrapper {
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 20px !important;
}

.el-dialog {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  margin: 0;
  padding: 0;
  top: 0 !important;
}
}
.full-screen-dialog .el-dialog__wrapper {
  width: 100vw;
  height: 100vh;
  margin: 0;
}

.full-screen-dialog .el-dialog__body {
  height: 100%;
  // padding: 0;
}

.el-select-dropdown__item span {
  padding-left: 10px !important; /* 根据需要调整左边距的值 */
}
.financingInner {
  .custom-button {
  background-color: #bf9d63;
  color: #fff;
  font-size: 1vw;
  padding: 0.5vw 1.5vw;
}

.custom-button:hover {
  background-color: darken(#bf9d63, 10%);
}
  .el-pagination .el-pager .active {
    background-color: #bf9d63 !important;
    color: #fff;
  }
  .myselect {
    margin-left: 15px;
    .ivu-select {
    }
    .ivu-select-selection {
      color: #bf9d63;
      background-color: transparent;
      border: 1px solid #bf9d63;
    }
    .ivu-select-placeholder {
      color: #bf9d63 !important;
    }
  }
  .popoverBackB.el-popover {
    background: #464b54 !important;
    border-color: #464b54;
  }
  .popoverBackB .popper__arrow::after {
    /* 注意：placement位置不同，下面的属性不同 */
    border-left-color: #464b54 !important;
  }
  .platedialog .el-dialog {
    .el-dialog__title {
      color: #464b54;
    }
    background-color: #ffffff;
  }
}
.yellowButton{
  background-color: #bf9d63 !important; /* 更换为您想要的颜色 */
  border-color: #bf9d63 !important;
}
.yellowLoading{
  color:#bf9d63 !important;
}
.el-loading-spinner   .path{
  stroke: #bf9d63 !important;
}
</style>
<style lang="less" scoped>
@import "~@/assets/less/index.less";

.financingInner {
  .changeWrap {
    display: flex;
    align-items: center;
    padding-left: 80px;
    position: relative;
    z-index: 20;
    img {
      width: 16px;
      cursor: pointer;
    }
    span {
      cursor: pointer;
      padding-left: 5px;
      font-size: 14px;
      color: #bf9d63;
    }
  }
  .hoverContent {
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(147, 147, 153, 0.5);
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    .hovertitle {
      color: #fff;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 10px;
    }
    .line {
      margin: 10px auto;
      height: 1px;
      flex-shrink: 0;
      opacity: 0.14;
      background: #fff;
    }
    .content {
      color: #b3b3b3;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .padding1 {
    //   padding-top: 0.5vw;
    //   padding-bottom: 0.5vw;
    min-height: 5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    flex-shrink: 0;
    flex-grow: 0;
    word-wrap: break-word; /* 允许在长单词内部换行 */
  word-break: break-all; /* 允许在任意位置换行 */
  }
  .borderLeft {
    border-left: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderTop {
    border-top: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderRight {
    border-right: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderBottom {
    border-bottom: solid 2px rgba(87, 87, 87, 0.5);
  }
  .part2 {
    .tableWrap {
      background: #2c3136;
      height: 60vh;
      margin-top: 1.5vw;
      font-weight: 600;
      border: solid 2px rgba(87, 87, 87, 0.5);

      .tableList {
        overflow-x: hidden;
        text-align: center;
        .titleWrap {
          display: flex;
          align-items: center;
          background: rgba(87, 87, 87, 0.5);
          color: #bf9d63;
        }
        .tableContentRow {
          display: flex;
          align-items: center;
          border-right: solid 2px rgba(87, 87, 87, 0.5);
          border-left: solid 2px rgba(87, 87, 87, 0.5);
          border-bottom: solid 2px rgba(87, 87, 87, 0.5);

          .tableItem {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            height: 2vw;
            width: 8vw;
            border-right: solid 2px rgba(87, 87, 87, 0.5);
          }
        }
      }
    }
    .topList {
      display: flex;
      align-items: center;
      .item {
        margin-right:3vw;
        width: 12vw;
        height: 7vw;
        flex-shrink: 0;
        border: 1px solid #4d4a48;
        background: rgba(87, 87, 87, 0.3);
        display: inline-block;
        .itemTitle {
          color: #bf9d63;
          font-family: Microsoft YaHei;
          font-size: 1vw;
          font-weight: 600;
        }
        .content {
          margin-top: 0.8vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .num {
            color: #fff;
            font-family: Microsoft YaHei;
            font-size: 2vw;
            font-style: normal;
            font-weight: 700;
            opacity: 0.8;
          }
          .unit {
            font-size: 1vw;
          }
        }
      }
    }
  }
  .content1 {
    color: #fff;
    opacity: 0.6;
    font-size: 1vw;
    padding: 2vw;
  }
  .content2 {
    color: #bf9d63;
    opacity: 0.6;
    font-size: 1vw;
    padding: 2vw;
  }
  .uploadButton {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 8vw;
    height: 3vw;
    font-size: 1vw;
    flex-shrink: 0;
    border-radius: 2px;
    border: 1px solid #bf9d63;
    background: #46423a;
    color: rgba(191, 157, 99, 1);
  }
  .yellowCorner {
    padding-left: 3%;
    padding-right: 4%;
    width: 100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding: 10px 20px;
  }
  .loadingWrap {
    margin-top: 12vh;
    text-align: center;
    .word {
      color: 999;
    }
  }
  .flow {
    // height: 38vh;
    width:40vw;
    border: 1px solid #4d4a48;
    background: rgba(87, 87, 87, 0.3);
    // display: flex;
    // align-items: center;
    .yellowCorner {
      // display: flex;
      align-items: center;
      padding: 3vh 3vw;
      padding-left: 1vw;
    }
    .flowLeft {
      display: flex;
      align-items: center;
      height: 100%;
      .dot {
        border-radius: 50%;
        width: 0.5vw;
        height: 0.5vw;
        background: linear-gradient(
          180deg,
          #bf9d63 0%,
          rgba(217, 217, 217, 0) 100%
        );
        margin-right: 0.5vw;
      }
      .word {
        color: #bf9d63;
        font-size: 1vw;
      }
    }
    .flowCenter {
      position: relative;
      margin-top:2vh;
      width: 100%;
      height:29vh;
      background: rgba(30, 34, 41, 1);
    }
    .flowRight {
      width: 100%;
      // height: 35vh;
      background: rgba(30, 34, 41, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      .noContent {
        text-align: center;
        .noword {
          color: #999;
        }
      }
    }
  }
  .top {
    height: 5vh;
    .left {
      color: #bf9d63;
      font-size: 1vw;
      float: left;
    }
    .right {
      float: right;
    }
  }
}
</style>
